import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import BookLanding from "@/pages/BookLanding";
import PaymentReturn from "@/pages/PaymentReturn";

function App() {
  return (
    <div className="App paper-bg">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BookLanding />} />
          <Route path="/payment/return" element={<PaymentReturn />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
